module.exports = __webpack_public_path__ + "img/the2018nukecollection.e7cce13b.png";